import { useSyncExternalStore } from 'react';

/**
 * The selected workspace slug (localStorage), sent to the API on every request as
 * `x-workspace-slug`. A Hive SSO launch lands with `?workspace=<slug>`, which wins.
 */
const STORAGE_KEY = 'sb-workspace';
const listeners = new Set<() => void>();

function readStored(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

function fromQuery(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return new URL(window.location.href).searchParams.get('workspace');
  } catch {
    return null;
  }
}

let current: string | null = fromQuery() ?? readStored();
if (current && typeof window !== 'undefined') {
  try {
    localStorage.setItem(STORAGE_KEY, current);
  } catch {
    // ignore
  }
}

export function getWorkspaceSlug(): string | null {
  return current;
}

export function setWorkspaceSlug(slug: string | null): void {
  if (slug === current) return;
  current = slug;
  try {
    if (slug) localStorage.setItem(STORAGE_KEY, slug);
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore storage failures
  }
  listeners.forEach((l) => l());
}

export function useWorkspaceSlug(): string | null {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    getWorkspaceSlug,
    getWorkspaceSlug,
  );
}

export const apiBase = (import.meta.env.VITE_API_URL ?? '').replace(/\/$/, '');
